import UIComponent from "../component";

export class BtnCopy extends UIComponent {
    init() {
        this.on("click", () => this.copy());
        this.includeComponents({
            resultTabs: 'document@[data-tbx-name="resultTabs"]',
            copyMessage: 'document@[data-tbx-name="copyMessage"]',
        });
        this.updateVisibility();
        this.resultTabs?.onChange?.(() => this.updateVisibility());
        this.resultTabs?.on?.("aiContentUpdated", () => this.updateVisibility());
    }

    htmlToCopyText(html) {
        if (!html) return "";
        const tmp = document.createElement("div");
        tmp.innerHTML = String(html);
        

        tmp.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));


        tmp.querySelectorAll("div").forEach((div) => {
            div.insertAdjacentText("beforebegin", "\n");
            div.insertAdjacentText("afterend", "\n");
        });

 
        tmp.querySelectorAll(
            "span[data-start-time] + span[data-start-time]"
        ).forEach((b) => {
            b.insertAdjacentText("beforebegin", " ");
        });

  
        tmp.querySelectorAll("li").forEach((li, index) => {
            const parent = li.parentElement;
            if (parent) {
                if (parent.tagName === 'OL') {
   
                    li.insertAdjacentText("afterbegin", `${index + 1}. `);
                } else if (parent.tagName === 'UL') {
      
                    li.insertAdjacentText("afterbegin", "• ");
                }
            }
        });

        return String(tmp.textContent || "")
            .replace(/\u00A0/g, " ")
            .replace(/[ \t]{2,}/g, " ")
            .replace(/[ \t]*\n[ \t]*/g, "\n")
            .replace(/\n{3,}/g, "\n\n")
            .trim();
    }

    async copy() {
    const html =
        this.resultTabs?.getCopyHtml?.() ||
        document.querySelector("#text_transcriber")?.innerHTML;
    const htmlString = String(html || "");
    const text = this.htmlToCopyText(htmlString);

    if (!text && !htmlString) return;

    try {

        let processedHtml = htmlString;
        

        if (htmlString && htmlString.includes('<')) {
    
            const styledHtml = `
                <div>
                    ${htmlString}
                </div>
            `;
            processedHtml = styledHtml;
        }

        if (navigator.clipboard?.write && window.ClipboardItem) {
            const htmlBlob = new Blob([processedHtml], { type: "text/html" });
            const textBlob = new Blob([text], { type: "text/plain" });
            await navigator.clipboard.write([
                new ClipboardItem({
                    "text/html": htmlBlob,
                    "text/plain": textBlob,
                }),
            ]);
        } else if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
        } else {
        
            const temp = document.createElement("div");
            temp.setAttribute("contenteditable", "true");
            temp.style.position = "fixed";
            temp.style.left = "-9999px";
            temp.style.top = "0";
            temp.innerHTML = processedHtml || text;
            document.body.appendChild(temp);
            const range = document.createRange();
            range.selectNodeContents(temp);
            const selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
            document.execCommand("copy");
            selection?.removeAllRanges();
            document.body.removeChild(temp);
        }
        this.copyMessage.show();
        setTimeout(() => this.copyMessage.hide(), 2500);
    } catch (e) {
        console.error("Copy failed:", e);
    }
}

    isActiveTabPending() {
        const tabId = this.resultTabs?.getActiveTabId?.();
        if (!tabId || tabId === "0") return false;
        
        const content =
            this.resultTabs?.getCopyContainer?.(tabId) ||
            document.querySelector?.(`[data-tab-content="${tabId}"]`) ||
            null;
            
        if (!content) return false;
        
        const preloader = content.querySelector?.(".ai_preloader");
        if (!preloader) return false;
        
        return !preloader.classList.contains("d-none");
    }

    updateVisibility() {
        const shouldShow = !this.isActiveTabPending();
        this.element?.classList?.toggle("d-none", !shouldShow);
    }
}